export default {
    title: 'MEMBER',
    section1: {
        heading: 'TAILORED ADVICE',
        description: 'Members have access to personalized service and expert advice.'
    },
    section2: {
        heading: 'PRIVILEGED ACCESS TO WINES',
        description: 'Members have access to allowances and certain products that are not on our lists.'
    },
    section3: {
        heading: 'PREFERENTIAL PRICES',
        description: 'Members have access to preferential prices on bottles sold individually.'
    },
    section4: {
        heading: 'TASTINGS BY APPOINTMENT',
        description: 'Members are entitled to up to 4 in-store tastings per year accompanied by a non-member person of their choice'
    },
    section5: {
        heading: 'PRIVATE EVENTS',
        list: [
            ' 5@7 with winegrowers',
            'Tastings new arrivals',
            'Exclusive events'
        ]
    },
    andMuchMore: 'And much more !',
    becomeMember: 'BECOME A MEMBER',
    plan: '150',
    subscribe: 'Subscribe',
    year: '/year'
};
